import { QRCodeSVG } from "qrcode.react";
import { Button } from "@/components/ui/button.tsx";
import { isCoarsePointer, isIOS } from "@/lib/utils.ts";
import { APP_STORE_URL } from "@/shared/appStore.ts";

/**
 * The way to the iPhone app from wherever the user is: the App Store on an
 * iPhone or iPad, a code to scan on a computer. Nothing on other phones,
 * where there is no app to get (a touchscreen laptop still gets the code).
 */
export const GetIphoneApp = ({ qrSize = 120 }: { qrSize?: number }) => {
  if (isIOS()) {
    return (
      <Button asChild data-statsig-name="get-iphone-app">
        <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
          Get the iPhone app
        </a>
      </Button>
    );
  }
  if (!canGetIphoneApp()) return null;
  return (
    <div className="flex flex-col items-center gap-2">
      <div className="rounded-lg bg-white p-2">
        <QRCodeSVG value={APP_STORE_URL} size={qrSize} title="Scan to get the Okthx iPhone app" />
      </div>
      <p className="text-xs text-muted-foreground">Scan with your iPhone camera</p>
    </div>
  );
};

/** Whether {@link GetIphoneApp} renders anything on this device. */
export const canGetIphoneApp = () => isIOS() || !isCoarsePointer();
